export const quantityManagerEvents = {
  SELECT_ADD_PRODUCT: "web_select_add_product",
  SELECT_SUBSTRACT_PRODUCT_QUANTITY: "web_select_substract_product_quantity",
  SELECT_ADD_PRODUCT_QUANTITY: "web_select_add_product_quantity",
};
